import React from "react";

export default function Contact() {
  const pageStyle = {
    padding: "30px",
  };

  const formContainer = {
    width: "90%",
    maxWidth: "700px",
    margin: "auto",
    padding: "25px",
    background: "white",
    borderRadius: "15px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #aaa",
  };

  const btnStyle = {
    width: "100%",
    padding: "14px",
    fontSize: "18px",
    background: "#4A148C",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "700",
  };

  const contactBox = {
    width: "90%",
    maxWidth: "700px",
    margin: "30px auto",
    padding: "20px",
    background: "#f7f2ff",
    borderRadius: "15px",
    border: "2px solid #4A148C",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
  };

  const text = {
    fontSize: "18px",
    margin: "8px 0",
    color: "#333",
  };

  return (
    <div style={pageStyle}>
      <h1 style={{ textAlign: "center", color: "#4A148C", fontSize: "32px", fontWeight: "800" }}>
        संपर्क करा
      </h1>

      {/* CONTACT DETAILS SECTION */}
      <div style={contactBox}>
        <h2 style={{ color: "#4A148C", marginBottom: "15px", textAlign: "center" }}>
          आमचा संपर्क
        </h2>

        <p style={text}>
          <b>📞 Phone:</b> 9623210159
        </p>

        <p style={text}>
          <b>📧 Email:</b> bdopsballarpur@gmail.com
        </p>
      </div>

      {/* FORM SECTION */}
      <div style={formContainer}>
        <h2 style={{ marginBottom: "20px", textAlign: "center", color: "#333" }}>
          संपर्क फॉर्म
        </h2>

        <input style={inputStyle} type="text" placeholder="आपले नाव" />
        <input style={inputStyle} type="email" placeholder="ईमेल" />
        <input style={inputStyle} type="text" placeholder="मोबाइल नंबर" />
        <textarea
          style={{ ...inputStyle, height: "120px" }}
          placeholder="आपला संदेश लिहा"
        ></textarea>

        <button style={btnStyle}>पाठवा</button>
      </div>

      {/* MAP SECTION */}
      <h2 style={{ textAlign: "center", marginTop: "40px", color: "#4A148C" }}>
        📍 आमचे स्थान
      </h2>

      <div
        style={{
          width: "90%",
          height: "450px",
          margin: "20px auto",
          borderRadius: "15px",
          overflow: "hidden",
          boxShadow: "0 6px 25px rgba(0,0,0,0.25)",
          border: "3px solid #4A148C",
        }}
      >
        <iframe
          title="Panchayat Samiti Ballarpur Map"
          width="100%"
          height="100%"
          loading="lazy"
          style={{ border: 0 }}
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15137.09996063855!2d79.3483367!3d19.8521892!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0:0x748c08436862a5da!2sPanchayat%20Samiti%20Office%20Balharshah!5e0!3m2!1sen!2sin!4v1700000000000"
        ></iframe>
      </div>
    </div>
  );
}
